module.exports = __webpack_public_path__ + "components/flag/static/square/in-a8b035d61b54fec572a00298f9a05aaa.svg";